import { ToastContainer } from 'react-toastify';
import './styles.sass';
import { useCallback } from 'react';

function CloseButton({ closeToast, type, ariaLabel }: any) {
    const onClick = useCallback(
        (e: React.MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation();
            closeToast(e);
        },
        [closeToast]
    );

    return (
        <button
            onClick={onClick}
            type="button"
            aria-label={ariaLabel}
            className={`notification__close-button notification__close-button--${type}`}
        />
    );
}

const Toast = () => {
    return (
        <ToastContainer
            position="bottom-right"
            autoClose={4000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            draggable
            pauseOnHover
            toastClassName="notification"
            className="notification__body"
            pauseOnFocusLoss={false}
            closeButton={<CloseButton />}
        />
    );
};

export default Toast;
